import { render, staticRenderFns } from "./RenovacaoTaxas.vue?vue&type=template&id=36c5d842"
import script from "./RenovacaoTaxas.vue?vue&type=script&lang=js"
export * from "./RenovacaoTaxas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports